import Vue from 'vue'
import Router from 'vue-router'
import homes from '@/pages/home'
import skinmgr from '@/pages/skinmgr'

import login from '@/components/login'
import register from '@/components/register'
import forget from '@/components/forget'

import error from '@/components/404'

import tipsList from '@/tips/list'
import tipsEdit from '@/tips/edit'

import goodsList from '@/goods/list'
import goodsEdit from '@/goods/edit'
import recordsList from '@/records/list'
import count from '@/default/count'

//配置
import qrbaseset from '@/config/qr'
import numberbaseset from '@/config/numberbaseset'
import layertextset from '@/config/layertextset'
import deeptextset from '@/config/deeptextset'
import syntextset from '@/config/syntextset'
import pushset from '@/config/pushset'
// import imageset from '@/config/imageset'
import datashowtype from '@/config/datashowtype'
import facearchitect from '@/config/facearchitect'

//营销
import question from '@/sell/question'
import lottory from '@/sell/lottory'
import editActive from '@/sell/editactive'

//成员
import memberList from '@/members/list'
import deviceList from '@/device/xuliema'
import deviceCreate from '@/device/xuliemaadd'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homes',
      component: homes,
      children: [
        {
          path: '',
          component: login
        },
        {
          path: 'login',
          component: login
        },
        {
          path: 'register',
          component: register
        },
        {
          path: 'forget',
          component: forget
        }
      ]
    },
    {
      path: '/skinmgr',
      name: 'skinmgr',
      component: skinmgr,
      children: [
        {
          path: 'home',
          component: count,
          meta: { auth: true }
        },
        {
          path: 'goodsList',
          component: goodsList,
          meta: { auth: true }
        },
        {
          path: 'goodsEdit',
          component: goodsEdit,
          meta: { auth: true }
        },
		{
		  path: 'tipsList',
		  component: tipsList,
		  meta: { auth: true }
		},
		{
		  path: 'tipsEdit',
		  component: tipsEdit,
		  meta: { auth: true }
		},
        {
          path: 'recordsList',
          component: recordsList,
          meta: { auth: true }
        },
        {
          path: 'qrbaseset',
          component: qrbaseset,
          meta: { auth: true }
        },
        {
          path: 'numberbaseset',
          component: numberbaseset,
          meta: { auth: true }
        },
        {
          path: 'layertextset',
          component: layertextset,
          meta: { auth: true }
        },
        {
          path: 'deeptextset',
          component: deeptextset,
          meta: { auth: true }
        },
        {
          path: 'syntextset',
          component: syntextset,
          meta: { auth: true }
        },
        {
          path: 'pushset',
          component: pushset,
          meta: { auth: true }
        },
        // {
        //   path: 'imageset',
        //   component: imageset,
        //   meta: { auth: true }
        // },
        {
          path: 'datashowtype',
          component: datashowtype,
          meta: { auth: true }
        },
          {
              path: 'facearchitect',
              component: facearchitect,
              meta: { auth: true }
          },
        {
          path: 'question',
          component: question,
          meta: { auth: true }
        },
        {
          path: 'lottory',
          component: lottory,
          meta: { auth: true }
        },
        {
          path: 'editActive',
          component: editActive,
          meta: { auth: true }
        },
        {
          path: 'memberList',
          component: memberList,
          meta: { auth: true }
        },
		{
		  path: 'deviceList',
		  component: deviceList,
		  meta: { auth: true }
		},
		{
		  path: 'deviceCreate',
		  component: deviceCreate,
		  meta: { auth: true }
		},
        {
          path: '*',
          component: error
        }
      ]
    },
    {
      path: '*',
      component: error
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js